module.exports = __webpack_public_path__ + "img/icon_06.249c8599.gif";